import httpClient from './_httpClient';

const END_POINT = '/clients';

const getAllClients = (paginated = true) => {
  let params = {};
  if (!paginated) {
    params.paginated = false;
  }
  return httpClient.get(END_POINT , {params})
};
const addClient = (clientData) => httpClient.post(END_POINT, clientData);
const editClient = (id, clientData) => httpClient.put(END_POINT + '/' + id, clientData);
const enableOrDisableClient = (id) => httpClient.put(END_POINT + '/enableOrDisableClient/' + id);
const deleteClient = (id) => httpClient.delete(END_POINT + '/' + id);
const getEnabledClientByScope = (scopeId) => httpClient.get(END_POINT + '/getEnabledClientByScope/'+scopeId);

export {
  getAllClients,
  addClient,
  editClient,
  enableOrDisableClient,
  deleteClient,
  getEnabledClientByScope,
}
